<div class="modal-header">
  <h1 class="modal-header__title">{{ title }}</h1>
  <img
    mfpLazyImage
    class="modal-header__close"
    lazySrc="assets/icons/close.svg"
    (click)="close()"
  />
</div>
